export default __webpack_public_path__ + "static/FirstsafetyImageFeature-a8af6f535118c6e72a6e6a88a6bf69ce.webp";